import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=6fadf46f&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=ts"
export * from "./Banner.vue?vue&type=script&lang=ts"
import style0 from "./Banner.vue?vue&type=style&index=0&id=6fadf46f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fadf46f",
  null
  
)

export default component.exports